import React from "react"
import BannerContainer from "@components/BannerContainer"
import WrapperInner from "@components/WrapperInner"
import TopTitle from "@components/TopTitle"
import AnchorButton from "@components/CTAAnchorButton"
import WhoWeAreImage from "./WhoWeAre.png"
import WhoWeAreMobileImage from "./WhoWeAre-Mobile.png"
import gridBreakpoints from "@styles/bs-modifiers/grid-breakpoints.js"
import styles from "./Banner.module.scss"
import classnames from "classnames/bind"

const Banner = props => {
  return (
    <BannerContainer
      renderLeftWrapperChildren={() => {
        return (
          <React.Fragment>
            <div
              className={
                styles.contentWrapper + " pr-lg-10 text-center text-lg-left"
              }
            >
              <h1
                className={classnames(
                  styles.title,
                  "proxima-nova--extra-bold",
                  "fs-30pt",
                  "text-white",
                  "mb-5",
                  "fs-lg-40pt",
                  "fs-xl-58pt"
                )}
              >
                <TopTitle content="ALL YOUR APPS ON ONE SCREEN" /> APP LAUNCH DASHBOARD
              </h1>
              <AnchorButton
                href="/demo"
                content="SEE A DEMO"
                className={styles.button}
              />
            </div>

            <div className={styles.emptyBlockLeft + " w-100 bg-white"}></div>
          </React.Fragment>
        )
      }}
      rightClassName="align-items-center text-center"
      renderRightWrapperChildren={() => {
        return (
          <React.Fragment>
            <WrapperInner>
              <picture>
                <source
                  media={`(min-width: ${gridBreakpoints.lg}px)`}
                  srcSet={WhoWeAreImage}
                  className={styles.whoWeAreImage + ""}
                />
                <source
                  media={`(min-width: ${gridBreakpoints.xs}px)`}
                  srcSet={WhoWeAreMobileImage}
                  className={styles.whoWeAreImage + ""}
                />
                <img
                  src={WhoWeAreImage}
                  alt="Who We Are"
                  className={styles.whoWeAreImage + ""}
                />
              </picture>
            </WrapperInner>
            <div className={styles.emptyBlockRight + " w-100 bg-white"}></div>
          </React.Fragment>
        )
      }}
    />
  )
}

export default Banner

